import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubmitMemberDiscountComponent } from './submit-member-discount.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PendingDiscountReviewComponent } from './pending-discount-review.component';
import { PendingDiscountsListComponent } from './pending-discounts-list.component';
import {NgbPagination, NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import { EditDiscountModalComponent } from './Modals/edit-discount-modal.component';
import { NgxMaskDirective } from 'ngx-mask';



@NgModule({
  declarations: [
    SubmitMemberDiscountComponent,
    PendingDiscountReviewComponent,
    PendingDiscountsListComponent,
    EditDiscountModalComponent
  ],
    imports: [
        CommonModule
        , FormsModule
        , RouterModule
        , ReactiveFormsModule, NgbPagination
        , NgxMaskDirective
        , NgbTooltipModule
    ]
})
export class MemberDiscountModule { }
